import React from "react";
import PropTypes from "prop-types";

import "./SelectBadges.scss";

const SelectBadges = props => {
	const { lang } = global;
	const {
		id,
		labelText,
		defaultOption,
		optionList,
		storedOptionList,
		handleOnChange,
		handleOnDelete,
		editPermission,
		editDone,
		dataTestId
	} = props;

	return (
		<div
			className="select-badges"
			id={id}
		>
			<If condition={labelText}>
				<label htmlFor="selectBadges">{labelText}</label>
			</If>
			<select
				name="selectBadges"
				className="form-control"
				onChange={e => handleOnChange(e)}
				data-test-id={dataTestId}
			>
				<option value="">{defaultOption}</option>
				<For
					each="item"
					of={optionList.filter(
						item =>
							!storedOptionList.find(
								option => item.value.toString() === option?.value.toString(),
							),
					)}
					index="index"
				>
					<option
						key={`item_${index}_${item.value}`}
						value={item.value}
					>
						{item.label}
					</option>
				</For>
			</select>
			<If condition={storedOptionList.length > 0}>
				<ul className="list-unstyled option-list">
					<For
						each="item"
						of={storedOptionList}
						index="index"
					>
						<li key={`list-item-${item.label}-${item.value}`}>
							<button
								type="button"
								className="btn btn-rounded"
								onClick={() => handleOnDelete(item.value)}
							>
								{item.label}
								<span className="badge">&#10005;</span>
							</button>
						</li>
					</For>
					<If condition={editPermission}>
						<button
							type="button"
							className="btn btn-link"
							onClick={editDone}
						>
							<i className="glyphicon glyphicon-ok" />
							&nbsp;
							{lang.t("Done")}
						</button>
					</If>
				</ul>
			</If>
		</div>
	);
};

SelectBadges.propTypes = {
	id: PropTypes.string,
	labelText: PropTypes.string,
	defaultOption: PropTypes.string.isRequired,
	optionList: PropTypes.array.isRequired,
	storedOptionList: PropTypes.array.isRequired,
	handleOnChange: PropTypes.func.isRequired,
	handleOnDelete: PropTypes.func.isRequired,
	editDone: PropTypes.func,
	editPermission: PropTypes.bool,
	dataTestId: PropTypes.string
};

SelectBadges.defaultProps = {
	id: undefined,
	labelText: "",
	editPermission: false,
	editDone: () => {},
	dataTestId: undefined
};

export default SelectBadges;
